import React, { useRef, useEffect } from "react";
import MessageBubble from "./MessageBubble";
import { MessageSquare, Sparkles } from "lucide-react";

/**
 * MessageList - Displays the list of chat messages with auto-scroll
 * @param {Array} messages - Array of message objects
 * @returns {JSX.Element}
 */
const MessageList = ({ messages }) => {
    const messagesEndRef = useRef(null);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    // Empty state
    if (messages.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-center px-8">
                <div className="w-16 h-16 bg-gradient-to-br from-acs-primary-green to-teal-400 rounded-2xl flex items-center justify-center mb-4 shadow-lg">
                    <Sparkles className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    Ascendrix
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                    Ask me anything about your shipments, invoices, and orders
                </p>
                <div className="bg-gray-50 rounded-2xl p-6 max-w-md w-full">
                    <p className="text-sm font-semibold text-gray-700 mb-4">
                        Try asking:
                    </p>
                    <ul className="space-y-3 text-left">
                        <li className="text-sm text-gray-600 bg-white px-4 py-3 rounded-xl shadow-sm">
                            "What is the status of shipment SH-12345?"
                        </li>
                        <li className="text-sm text-gray-600 bg-white px-4 py-3 rounded-xl shadow-sm">
                            "Show me invoice details for INV-001"
                        </li>
                        <li className="text-sm text-gray-600 bg-white px-4 py-3 rounded-xl shadow-sm">
                            "What orders are pending for my office?"
                        </li>
                    </ul>
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-4 py-4">
            {messages.map((message) => (
                <MessageBubble key={message.id} message={message} />
            ))}
            <div ref={messagesEndRef} />
        </div>
    );
};

export default MessageList;
